<style lang="scss">
</style>

<template>
<div class="search-wrap">
    <article class="search-main clearfix">
        <div class="pull-right">
            <Form :label-width="60" inline>
                <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                    <!-- <Input clearable v-model.trim="formData.EQ_lineId" placeholder="项目"/> -->
                    <Select clearable v-model="formData.EQ_lineId" filterable>
                        <Option v-for="item in getNewDifferentAllProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem> 
                <FormItem label='ERPSKU'>
                    <Input clearable v-model.trim="formData.EQ_erpSku" placeholder="ERPSKU"/>
                </FormItem>
                <FormItem :label="$t('erp.virtualstore.entitywarehouse',{defaultValue:'实体仓'})">
                    <Select clearable v-model="formData.EQ_orgWarehouseId" filterable >
                        <Option v-for="item in warehouses" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                
                <FormItem :label-width="1">
                    <Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
                    <Button @click="reset" icon='md-refresh'>{{$t('erp.disturibution.reset_order',{defaultValue:'重置'})}}</Button>
                    <Button @click="downloadExcl" icon='md-refresh'>{{$t('erp.b2c.condition_export',{defaultValue:'查询条件导出'})}}</Button>
                    <Button type="text" @click="isOpen=!isOpen">{{$t('global.common.operates',{defaultValue:'更多操作'})}}<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                </FormItem>
            </Form>
        </div>
    </article>
    <transition name='slide-both'>
        <Form class="search-other" :label-width="102" inline v-show="isOpen">
            <FormItem :label="$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'})">
                <Select
                v-model="formData.EQ_stockVirtualGroupRuleItemId"
                filterable
                clearable
                @on-query-change="getVsGroups">
                    <Option v-for="item in vsgroups" :value="item.id" :key="item.id">{{ item.warehouseTitle }}-{{item.ruleName}}</Option>
                </Select>
            </FormItem>
            <FormItem :label="$t('fbb.accountmanage.amount',{defaultValue:'数量'})">
                <Input style="width:40%" clearable v-model.trim="formData.GE_quantity" :placeholder="$t('fbb.accountmanage.amount',{defaultValue:'数量'})"/> - 
                <Input style="width:40%" clearable v-model.trim="formData.LE_quantity" :placeholder="$t('fbb.accountmanage.amount',{defaultValue:'数量'})"/>
            </FormItem>
        </Form>
    </transition>
</div>
</template>

<script>

import { mapState,mapGetters } from 'vuex'
import { HttpGroupRuleItem } from '@/service/boss/allot'
export default {
    data() {
        return {
            vsgroups: [],
            formData: {
                EQ_lineId: '',
                EQ_erpSku: '',
                EQ_orgWarehouseId: '',
                EQ_stockVirtualGroupRuleItemId: '',
                LE_quantity:'',
                GE_quantity:'',
            },
            isOpen:false,
        };
    },
    mounted() {
        this.update();
        this.getVsGroups();
    },
    computed: {
        ...mapGetters('diction',['getNewDifferentAllProductList','getNewWarehouseIdList']),
        warehouses(){
            return this.getNewWarehouseIdList.filter(item=>{
                return item.attach.item.warehouseType !== 2 && item.attach.item.warehouseType !== 4
            })
        }
    },
    methods: {
        update() {
            this.$emit('on-update', {
                search: {
                    ...this.formData,
                    EQ_status: 'ACTIVE',
                },
                page: 1
            });
        },
        reset() {
            this.formData = {
                EQ_lineId: '',
                EQ_erpSku: '',
                EQ_orgWarehouseId: '',
                EQ_stockVirtualGroupRuleItemId: '',
                LE_quantity:'',
                GE_quantity:'',
            };
            this.$emit('on-update', {
                search: {
                    ...this.formData,
                    EQ_status: 'ACTIVE',
                },
                page: 1
            });
        },
        async getVsGroups(query = "") {
            HttpGroupRuleItem({
                page: 1,
                rows: 50,
                sidx: 'id',
                sord: 'desc',
                search: {
                    'CN_stockVirtualGroupRuleEntity.name': query
                }
            }).then(res => {
                this.vsgroups = res.data.content;
            });
        },
        downloadExcl(){
            if(sessionStorage.get("downloadTotal")>2000){
                this.$Message.error(this.$t('erp.channel.export_2000',{defaultValue:'请导出2000条以内的数据'}));
            }else{
                this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +"/api/v2/StockGroupInventory/export", { 
                    "search[EQ_lineId]": this.formData.EQ_lineId ? this.formData.EQ_lineId : '',
                    "search[EQ_erpSku]": this.formData.EQ_erpSku ? this.formData.EQ_erpSku : '',  
                    "search[EQ_orgWarehouseId]": this.formData.EQ_orgWarehouseId ? this.formData.EQ_orgWarehouseId : '',
                    "search[EQ_stockVirtualGroupRuleItemId]": this.formData.EQ_stockVirtualGroupRuleItemId ? this.formData.EQ_stockVirtualGroupRuleItemId : '',
                    "search[LE_quantity]":this.formData.LE_quantity ? this.formData.LE_quantity : '', 
                    "search[GE_quantity]":this.formData.GE_quantity ? this.formData.GE_quantity : '', 
                    "search[EQ_status]":'ACTIVE'
                }, 'download') 
            }
        }
    },
};
</script>
